// Путь: D:\QR\QR-WEB\dashboard\src\components\Business\BusinessMarketplace.jsx
// Название: Business Marketplace - Обмен DAR на ценности
// Версия: 1.0.0
// Дата: 20.06.2025

import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import './BusinessMarketplace.css';

const BusinessMarketplace = () => {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    loadBalance();
  }, []);

  const loadBalance = async () => {
    try {
      const userId = localStorage.getItem('userId');
      const res = await api.get(`/balance/${userId}`);
      setBalance(parseFloat(res.data?.data?.available_amount || 0));
    } catch (err) {
      console.error('Balance error:', err);
    } finally {
      setLoading(false);
    }
  };

  const categories = [
    { id: 'all', name: 'Все', icon: '🏠' },
    { id: 'giftcards', name: 'Gift Cards', icon: '🎁' },
    { id: 'mobile', name: 'Мобильная связь', icon: '📱' },
    { id: 'games', name: 'Игры', icon: '🎮' },
    { id: 'subscriptions', name: 'Подписки', icon: '📺' }
  ];

  const products = [
    { id: 1, category: 'giftcards', name: 'Amazon Gift Card', price: 50, icon: '🛒', available: true },
    { id: 2, category: 'giftcards', name: 'Google Play', price: 25, icon: '▶️', available: true },
    { id: 3, category: 'giftcards', name: 'App Store & iTunes', price: 50, icon: '🍎', available: true },
    { id: 4, category: 'giftcards', name: 'Steam Wallet', price: 20, icon: '🎮', available: true },
    { id: 5, category: 'mobile', name: 'Пополнение мобильного', price: 10, icon: '📱', available: false },
    { id: 6, category: 'games', name: 'PlayStation Store', price: 50, icon: '🎮', available: true },
    { id: 7, category: 'games', name: 'Xbox Gift Card', price: 50, icon: '🎯', available: true },
    { id: 8, category: 'games', name: 'Nintendo eShop', price: 25, icon: '🕹️', available: false },
    { id: 9, category: 'subscriptions', name: 'Netflix', price: 15, icon: '📺', available: false },
    { id: 10, category: 'subscriptions', name: 'Spotify', price: 10, icon: '🎵', available: false },
    { id: 11, category: 'giftcards', name: 'Zalando', price: 50, icon: '👗', available: true },
    { id: 12, category: 'giftcards', name: 'IKEA', price: 50, icon: '🏠', available: false }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  const handlePurchase = (product) => {
    if (!product.available) {
      alert('Этот товар временно недоступен');
      return;
    }
    if (balance < product.price) {
      alert(`Недостаточно средств. Нужно ${product.price} DAR, доступно ${balance.toFixed(2)} DAR`);
      return;
    }
    alert(`🚧 Маркетплейс в разработке\n\nСкоро вы сможете обменять ${product.price} DAR на ${product.name}`);
  };

  if (loading) {
    return <div className="marketplace-loading">Загрузка...</div>;
  }

  return (
    <div className="marketplace-container">
      <div className="marketplace-header">
        <div>
          <h1>🛒 Маркетплейс</h1>
          <p>Обменяйте DAR на цифровые товары и услуги</p>
        </div>
        <div className="marketplace-balance">
          <span className="balance-label">Доступно:</span>
          <span className="balance-value">{balance.toFixed(2)} DAR</span>
        </div>
      </div>

      <div className="marketplace-categories">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`category-btn ${selectedCategory === cat.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat.id)}
          >
            <span className="category-icon">{cat.icon}</span>
            <span className="category-name">{cat.name}</span>
          </button>
        ))}
      </div>

      <div className="marketplace-info">
        <div className="info-card">
          <span className="info-icon">💡</span>
          <div>
            <strong>Как это работает?</strong>
            <p>Выберите товар, оплатите баллами DAR и получите код мгновенно на email</p>
          </div>
        </div>
      </div>

      <div className="marketplace-grid">
        {filteredProducts.map(product => (
          <div key={product.id} className={`product-card ${!product.available ? 'disabled' : ''}`}>
            <div className="product-icon">{product.icon}</div>
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <div className="product-price">{product.price} DAR</div>
            </div>
            <button 
              className="product-btn"
              onClick={() => handlePurchase(product)}
              disabled={!product.available}
            >
              {product.available ? 'Получить' : 'Скоро'}
            </button>
            {!product.available && <div className="product-badge">Скоро</div>}
          </div>
        ))}
      </div>

      <div className="marketplace-footer">
        <p>🔒 Все транзакции защищены. Коды доставляются мгновенно на ваш email.</p>
        <p>📧 Поддержка: support@dary.one</p>
      </div>
    </div>
  );
};

export default BusinessMarketplace;
